
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/TrackDat/Manual",
      function () {
        return require("private-next-pages/TrackDat/Manual.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/TrackDat/Manual"])
      });
    }
  